import { 
    CREATE_COACH_TUTOR_AVAILABILITY_FAILURE,
    CREATE_COACH_TUTOR_AVAILABILITY_REQUEST,
    CREATE_COACH_TUTOR_AVAILABILITY_RESET,
    CREATE_COACH_TUTOR_AVAILABILITY_SUCCESS,

    DELETE_COACH_TUTOR_AVAILABILITY_FAILURE,
    DELETE_COACH_TUTOR_AVAILABILITY_REQUEST,
    DELETE_COACH_TUTOR_AVAILABILITY_RESET,
    DELETE_COACH_TUTOR_AVAILABILITY_SUCCESS,

    FETCH_COACH_TUTOR_AVAILABILITY_FAILURE,
    FETCH_COACH_TUTOR_AVAILABILITY_REQUEST,
    FETCH_COACH_TUTOR_AVAILABILITY_RESET,
    FETCH_COACH_TUTOR_AVAILABILITY_SUCCESS,

    FETCH_HISTORY_COACH_TUTOR_AVAILABILITY_FAILURE,
    FETCH_HISTORY_COACH_TUTOR_AVAILABILITY_REQUEST,
    FETCH_HISTORY_COACH_TUTOR_AVAILABILITY_RESET,
    FETCH_HISTORY_COACH_TUTOR_AVAILABILITY_SUCCESS,

    CREATE_WEEKLY_HOURS_COACH_AVAILABILITY_FAILURE,
    CREATE_WEEKLY_HOURS_COACH_AVAILABILITY_REQUEST,
    CREATE_WEEKLY_HOURS_COACH_AVAILABILITY_RESET,
    CREATE_WEEKLY_HOURS_COACH_AVAILABILITY_SUCCESS,

    FETCH_WEEKLY_HOURS_COACH_AVAILABILITY_FAILURE,
    FETCH_WEEKLY_HOURS_COACH_AVAILABILITY_REQUEST,
    FETCH_WEEKLY_HOURS_COACH_AVAILABILITY_RESET,
    FETCH_WEEKLY_HOURS_COACH_AVAILABILITY_SUCCESS,

    UPDATE_WEEKLY_HOURS_COACH_AVAILABILITY_FAILURE,
    UPDATE_WEEKLY_HOURS_COACH_AVAILABILITY_REQUEST,
    UPDATE_WEEKLY_HOURS_COACH_AVAILABILITY_RESET,
    UPDATE_WEEKLY_HOURS_COACH_AVAILABILITY_SUCCESS,

    DELETE_WEEKLY_HOURS_COACH_AVAILABILITY_FAILURE,
    DELETE_WEEKLY_HOURS_COACH_AVAILABILITY_REQUEST,
    DELETE_WEEKLY_HOURS_COACH_AVAILABILITY_RESET,
    DELETE_WEEKLY_HOURS_COACH_AVAILABILITY_SUCCESS
} from "./ManageCoachTutorAvailabilityTypes"


import axios from "axios";

export const createCoachTutorAvailabilityReset = () => {
    return {
        type: CREATE_COACH_TUTOR_AVAILABILITY_RESET,
    }
}

const createCoachTutorAvailabilityRequest = () => {
    return {
        type: CREATE_COACH_TUTOR_AVAILABILITY_REQUEST,
    }
}

const createCoachTutorAvailabilitySuccess = success => {
    return {
        type: CREATE_COACH_TUTOR_AVAILABILITY_SUCCESS,
        payload: success
    }
}

const createCoachTutorAvailabilityFailure = error => {
    return {
        type: CREATE_COACH_TUTOR_AVAILABILITY_FAILURE,
        payload : error
    }
}

export const createCoachTutorAvailability = (data) => {

    return (dispatch) => {

        dispatch(createCoachTutorAvailabilityRequest());
        
        
        
        axios.post('/createCoachTutorAvailability', data)
        .then(response => {
            const createCoachTutorAvailability = response.data
            dispatch(createCoachTutorAvailabilitySuccess(createCoachTutorAvailability))
            
        })
        .catch(error => {
            const errorMsg = error.message
            dispatch(createCoachTutorAvailabilityFailure(errorMsg))
        })
        
    }

}


export const deleteCoachTutorAvailabilityReset = () => {
    return {
        type: DELETE_COACH_TUTOR_AVAILABILITY_RESET,
    }
}

const deleteCoachTutorAvailabilityRequest = () => {
    return {
        type: DELETE_COACH_TUTOR_AVAILABILITY_REQUEST,
    }
}

const deleteCoachTutorAvailabilitySuccess = success => {
    return {
        type: DELETE_COACH_TUTOR_AVAILABILITY_SUCCESS,
        payload: success
    }
}

const deleteCoachTutorAvailabilityFailure = error => {
    return {
        type: DELETE_COACH_TUTOR_AVAILABILITY_FAILURE,
        payload : error
    }
}

export const deleteCoachTutorAvailability = (data) => {

    return (dispatch) => {

        dispatch(deleteCoachTutorAvailabilityRequest());
        
        
        
        axios.post('/deleteCoachTutorAvailability', data)
        .then(response => {
            const deleteCoachTutorAvailability = response.data
            dispatch(deleteCoachTutorAvailabilitySuccess(deleteCoachTutorAvailability))
            
        })
        .catch(error => {
            const errorMsg = error.message
            dispatch(deleteCoachTutorAvailabilityFailure(errorMsg))
        })
        
    }

}


export const fetchCoachTutorAvailabilityReset = () => {
    return {
        type: FETCH_COACH_TUTOR_AVAILABILITY_RESET,
    }
}

const fetchCoachTutorAvailabilityRequest = () => {
    return {
        type: FETCH_COACH_TUTOR_AVAILABILITY_REQUEST,
    }
}

const fetchCoachTutorAvailabilitySuccess = success => {
    return {
        type: FETCH_COACH_TUTOR_AVAILABILITY_SUCCESS,
        payload: success
    }
}

const fetchCoachTutorAvailabilityFailure = error => {
    return {
        type: FETCH_COACH_TUTOR_AVAILABILITY_FAILURE,
        payload : error
    }
}

export const fetchCoachTutorAvailability = (data) => {

    return (dispatch) => {

        dispatch(fetchCoachTutorAvailabilityRequest());
        
        
        
        axios.post('/fetchCoachTutorAvailability', data)
        .then(response => {
            const fetchCoachTutorAvailability = response.data
            dispatch(fetchCoachTutorAvailabilitySuccess(fetchCoachTutorAvailability))
            
        })
        .catch(error => {
            const errorMsg = error.message
            dispatch(fetchCoachTutorAvailabilityFailure(errorMsg))
        })
        
    }

}


export const fetchHistoryCoachTutorAvailabilityReset = () => {
    return {
        type: FETCH_HISTORY_COACH_TUTOR_AVAILABILITY_RESET,
    }
}

const fetchHistoryCoachTutorAvailabilityRequest = () => {
    return {
        type: FETCH_HISTORY_COACH_TUTOR_AVAILABILITY_REQUEST,
    }
}

const fetchHistoryCoachTutorAvailabilitySuccess = success => {
    return {
        type: FETCH_HISTORY_COACH_TUTOR_AVAILABILITY_SUCCESS,
        payload: success
    }
}

const fetchHistoryCoachTutorAvailabilityFailure = error => {
    return {
        type: FETCH_HISTORY_COACH_TUTOR_AVAILABILITY_FAILURE,
        payload : error
    }
}

export const fetchHistoryCoachTutorAvailability = (data) => {

    return (dispatch) => {

        dispatch(fetchHistoryCoachTutorAvailabilityRequest());
        
        
        
        axios.post('/fetchHistoryCoachTutorAvailability', data)
        .then(response => {
            const fetchHistoryCoachTutorAvailability = response.data
            dispatch(fetchHistoryCoachTutorAvailabilitySuccess(fetchHistoryCoachTutorAvailability))
            
        })
        .catch(error => {
            const errorMsg = error.message
            dispatch(fetchHistoryCoachTutorAvailabilityFailure(errorMsg))
        })
        
    }

}


export const createWeeklyHoursCoachAvailabilityReset = () => {
    return {
        type: CREATE_WEEKLY_HOURS_COACH_AVAILABILITY_RESET,
    }
}

const createWeeklyHoursCoachAvailabilityRequest = () => {
    return {
        type: CREATE_WEEKLY_HOURS_COACH_AVAILABILITY_REQUEST,
    }
}

const createWeeklyHoursCoachAvailabilitySuccess = success => {
    return {
        type: CREATE_WEEKLY_HOURS_COACH_AVAILABILITY_SUCCESS,
        payload: success
    }
}

const createWeeklyHoursCoachAvailabilityFailure = error => {
    return {
        type: CREATE_WEEKLY_HOURS_COACH_AVAILABILITY_FAILURE,
        payload : error
    }
}

export const createWeeklyHoursCoachAvailability = (data) => {

    return (dispatch) => {

        dispatch(createWeeklyHoursCoachAvailabilityRequest());
        
        
        
        axios.post('/createWeeklyHoursCoachAvailability', data)
        .then(response => {
            const createWeeklyHoursCoachAvailability = response.data
            dispatch(createWeeklyHoursCoachAvailabilitySuccess(createWeeklyHoursCoachAvailability))
            
        })
        .catch(error => {
            const errorMsg = error.message
            dispatch(createWeeklyHoursCoachAvailabilityFailure(errorMsg))
        })
        
    }

}


export const fetchWeeklyHoursCoachAvailabilityReset = () => {
    return {
        type: FETCH_WEEKLY_HOURS_COACH_AVAILABILITY_RESET,
    }
}

const fetchWeeklyHoursCoachAvailabilityRequest = () => {
    return {
        type: FETCH_WEEKLY_HOURS_COACH_AVAILABILITY_REQUEST,
    }
}

const fetchWeeklyHoursCoachAvailabilitySuccess = success => {
    return {
        type: FETCH_WEEKLY_HOURS_COACH_AVAILABILITY_SUCCESS,
        payload: success
    }
}

const fetchWeeklyHoursCoachAvailabilityFailure = error => {
    return {
        type: FETCH_WEEKLY_HOURS_COACH_AVAILABILITY_FAILURE,
        payload : error
    }
}

export const fetchWeeklyHoursCoachAvailability = (data) => {

    return (dispatch) => {

        dispatch(fetchWeeklyHoursCoachAvailabilityRequest());
        
        
        
        axios.post('/fetchWeeklyHoursCoachAvailability', data)
        .then(response => {
            const fetchWeeklyHoursCoachAvailability = response.data
            dispatch(fetchWeeklyHoursCoachAvailabilitySuccess(fetchWeeklyHoursCoachAvailability))
            
        })
        .catch(error => {
            const errorMsg = error.message
            dispatch(fetchWeeklyHoursCoachAvailabilityFailure(errorMsg))
        })
        
    }

}


export const updateWeeklyHoursCoachAvailabilityReset = () => {
    return {
        type: UPDATE_WEEKLY_HOURS_COACH_AVAILABILITY_RESET,
    }
}

const updateWeeklyHoursCoachAvailabilityRequest = () => {
    return {
        type: UPDATE_WEEKLY_HOURS_COACH_AVAILABILITY_REQUEST,
    }
}

const updateWeeklyHoursCoachAvailabilitySuccess = success => {
    return {
        type: UPDATE_WEEKLY_HOURS_COACH_AVAILABILITY_SUCCESS,
        payload: success
    }
}

const updateWeeklyHoursCoachAvailabilityFailure = error => {
    return {
        type: UPDATE_WEEKLY_HOURS_COACH_AVAILABILITY_FAILURE,
        payload : error
    }
}

export const updateWeeklyHoursCoachAvailability = (data) => {

    return (dispatch) => {

        dispatch(updateWeeklyHoursCoachAvailabilityRequest());
        
        
        
        axios.post('/updateWeeklyHoursCoachAvailability', data)
        .then(response => {
            const updateWeeklyHoursCoachAvailability = response.data
            dispatch(updateWeeklyHoursCoachAvailabilitySuccess(updateWeeklyHoursCoachAvailability))
            
        })
        .catch(error => {
            const errorMsg = error.message
            dispatch(updateWeeklyHoursCoachAvailabilityFailure(errorMsg))
        })
        
    }

}


export const deleteWeeklyHoursCoachAvailabilityReset = () => {
    return {
        type: DELETE_WEEKLY_HOURS_COACH_AVAILABILITY_RESET,
    }
}

const deleteWeeklyHoursCoachAvailabilityRequest = () => {
    return {
        type: DELETE_WEEKLY_HOURS_COACH_AVAILABILITY_REQUEST,
    }
}

const deleteWeeklyHoursCoachAvailabilitySuccess = success => {
    return {
        type: DELETE_WEEKLY_HOURS_COACH_AVAILABILITY_SUCCESS,
        payload: success
    }
}

const deleteWeeklyHoursCoachAvailabilityFailure = error => {
    return {
        type: DELETE_WEEKLY_HOURS_COACH_AVAILABILITY_FAILURE,
        payload : error
    }
}

export const deleteWeeklyHoursCoachAvailability = (data) => {

    return (dispatch) => {

        dispatch(deleteWeeklyHoursCoachAvailabilityRequest());
        
        
        
        axios.post('/deleteWeeklyHoursCoachAvailability', data)
        .then(response => {
            const deleteWeeklyHoursCoachAvailability = response.data
            dispatch(deleteWeeklyHoursCoachAvailabilitySuccess(deleteWeeklyHoursCoachAvailability))
            
        })
        .catch(error => {
            const errorMsg = error.message
            dispatch(deleteWeeklyHoursCoachAvailabilityFailure(errorMsg))
        })
        
    }

}